module.exports = __webpack_public_path__ + "static/media/Which Term is Right For You.080c4eda.pdf";